import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { FaPen } from 'react-icons/fa';
import { Toaster } from 'react-hot-toast';
import Pagination from 'components/pagination';
import { apiCall } from 'utils/apiClient';

const ListPartner = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 300);
    return () => clearTimeout(delay);
  }, [searchTerm]);

  const ApiFetch = async () => {
    const body = {
      page: currentPage,
      limit: recordsPerPage,
      search: debouncedSearch
    };

    try {
      const res = await apiCall({
        endpoint: "partner/list",
        method: "POST",
        data: body,
      });

      if (res.status === 200) {
        setData(res.data || []);
        setTotalRecords(res.pagination?.total_records || 0);
        setTotalPages(res.pagination?.total_pages || 0);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    ApiFetch();
  }, [currentPage, recordsPerPage, debouncedSearch]);

  const RedirectToAddPartner = () => {
    navigate("/add-partner");
  };

  const redirectToEditPartner = (partner) => {
    navigate("/add-partner", {
      state: { editPartner: partner },
    });
  };

  const formatDob = (dob) => {
    if (!dob) return "-";
    const parsed = new Date(dob);
    if (Number.isNaN(parsed.getTime())) return String(dob);
    return parsed.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Toaster position="top-center" reverseOrder={false} />

      <div className="border-solid border-2 mt-6 bg-white rounded-lg shadow-sm">
        <div className="text-lg font-semibold px-8 pt-6">List Partner</div>

        {/* Search & Add */}
        <div className="flex flex-wrap items-center justify-between px-8 py-3 gap-3">
          <input
            type="text"
            placeholder="Search Partner..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg p-2 w-full sm:w-1/2"
          />
          <div className="flex items-center gap-3">
            <button
              onClick={RedirectToAddPartner}
              className="px-3 py-2 text-xs font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600"
            >
              Add New
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm text-left border rounded-md">
            <thead className="border-b bg-gray-100 font-medium text-gray-700">
              <tr>
                <th className="px-4 py-3 text-center">Sr.No</th>
                <th className="px-4 py-3 text-center">Name</th>
                <th className="px-4 py-3 text-center">Mobile</th>
                <th className="px-4 py-3 text-center">Status</th>
                <th className="px-4 py-3 text-center">Document Status</th>
                <th className="px-4 py-3 text-center">Bank Status</th>
                <th className="px-4 py-3 text-center">Work</th>
                <th className="px-4 py-3 text-center">Area</th>
                <th className="px-4 py-3 text-center">Labour Count</th>
                <th className="px-4 py-3 text-center">DOB</th>
                <th className="px-4 py-3 text-center">Actions</th>
              </tr>
            </thead>

            <tbody className="text-center text-gray-800">
              {data.map((item, index) => (
                <tr key={item.id} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3">
                    {(currentPage - 1) * recordsPerPage + index + 1}
                  </td>

                  {/* ✅ CLICKABLE NAME */}
                  <td
                    className="px-4 py-3 text-blue-600 cursor-pointer hover:underline"
                    onClick={() =>
                      navigate("/partner-details", {
                        state: { partner: item },
                      })
                    }
                  >
                    {item.name}
                  </td>

                  <td className="px-4 py-3">{item.mobile}</td>
                  <td className="px-4 py-3">{item.status}</td>
                  <td className="px-4 py-3">{item.documents_verified}</td>
                  <td className="px-4 py-3">{item.bank_verified}</td>
                  <td className="px-4 py-3">{item.profession}</td>
                  <td className="px-4 py-3">{item.service_areas}</td>
                  <td className="px-4 py-3">{item.team_size}</td>
                  <td className="px-4 py-3">{formatDob(item.dob)}</td>

                  {/* Pen Icon (unchanged) */}
                  <td className="px-4 py-3">
                    <FaPen
                      className="text-green-600 hover:text-green-800 cursor-pointer mx-auto"
                      size={18}
                      onClick={() => redirectToEditPartner(item)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="px-6 py-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
            recordsPerPage={recordsPerPage}
            onRecordsPerPageChange={(val) => {
              setCurrentPage(1);
              setRecordsPerPage(val);
            }}
            totalRecords={totalRecords}
            count={data.length}
          showFirstLastControls
          compact
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ListPartner;
